module.exports = __webpack_public_path__ + "img/republic-of-the-philippines-logo.531ce39c.jpg";